import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LocationService } from '../location.service';
import { MessagerComponent } from 'src/app/messager/messager/messager.component';

@Component({
  selector: 'app-form-log-modal',
  templateUrl: './form-log.html',

})
export class FormLogsComponent implements OnInit{

  selectedDate: string = ''; // Track the selected date
  filteredData: any[] = []; // Array to hold filtered objects
  showTooltip: boolean = false;
  jobs: any[] = [];
  jobOutput: string = '';
  search: any;
  displayedData: any[] = [];
  applogData: any[] = [];
  showApplogData: boolean = false;
  showEmailData: boolean = false;
  isApplogDataLoaded: boolean = false;
  isEmailDataLoaded: boolean = false;
  showImages: boolean = false;
  private mouseOverHandler; 
  private mouseLeaveHandler; 
  applogDataFetched: boolean = false; 
  applogViewRequested: boolean = false;
  fullStory: boolean = false;

  constructor(public dialogRef: MatDialogRef<FormLogsComponent>, public messager: MessagerComponent, public locService: LocationService, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public http: HttpClient) {

    this.mouseOverHandler = this.onMouseEnter.bind(this);
    this.mouseLeaveHandler = this.onMouseLeave.bind(this); 
  }
  
  ngOnInit(): void {

    this.isApplogDataLoaded = true;
    if(this.data.all == true){
      const uniqueDates = this.getUniqueDates(this.data.formData);
      if (uniqueDates.length > 0) {
        this.selectDate(uniqueDates[0]);
        this.filteredData = this.displayedData;
      }
    }else {
      // nothing
      this.filteredData = this.data.formData;
      this.displayedData = this.filteredData;
    }

    this.locService.getFormLogJobs(this.data.location_id).subscribe(
      res => {
        this.jobs = res.Jobs;
      }, err => {
        console.log(err);
      }
    );

    this.locService.getApplogData(this.data.location_id).subscribe(
        res => {
          console.log(res);
          this.applogDataFetched = true;
          this.isApplogDataLoaded = false;

          this.applogData = res.Data;
          if (this.applogViewRequested) {
            this.changeToApplog(); 
          }
          
        }
    )


  }


  ngAfterViewInit(): void {
    //load jobs for this home
  }

  private onMouseLeave(event: Event): void {
    const modal = document.getElementById('imgModal');
    if (modal) {
      modal.style.display = 'none';
    }
  }
  
  private onMouseEnter(event: Event): void {
    const anchor = event.currentTarget as HTMLAnchorElement;
    const modal = document.getElementById('imgModal');
    if (modal) {
      modal.style.display = 'block';
      const modalImg = document.getElementById('img01') as HTMLImageElement;
      if (modalImg) {
        modalImg.src = anchor.href;
      }
    }
  }

  setFullStory(): void {
    this.fullStory = !this.fullStory;
    this.selectDate(this.selectedDate);
  }

  getUniqueDates(items: any[]): string[] {

    const dateSet = new Set<string>();
    items.forEach(item => {
      const datePart = item.created_at.split('T')[0]; // Extract the date part
      dateSet.add(datePart);
    });
    return Array.from(dateSet);

  }

 toggleImagePreview(): void {
    this.showImages = !this.showImages;

    const anchors = document.querySelectorAll('a');

    if (this.showImages) {
      anchors.forEach(anchor => {
        anchor.addEventListener('mouseover', this.mouseOverHandler);
        anchor.addEventListener('mouseout', this.mouseLeaveHandler);
      });
    } else {
      anchors.forEach(anchor => {
        anchor.removeEventListener('mouseover', this.mouseOverHandler);
        anchor.removeEventListener('mouseout', this.mouseLeaveHandler);
      });

      // Ensure modal is hidden when images are toggled off
      const modal = document.getElementById('imgModal');
      if (modal) {
        modal.style.display = 'none';
      }
    }
  }
  
  applyFilter() {
    if (!this.search) {
      this.displayedData = this.filteredData; // No search query, show all data
    } else {
      this.displayedData = this.filteredData.filter(obj => {
        return obj.item.toLowerCase().includes(this.search.trim().toLowerCase());
      });
    }
  }

  findScheduledJob(date): string {

    const jobs = this.jobs.filter((job: any) => job.schedule_date.split('T')[0] === date);
    let output = '';
    if (jobs.length > 0) {
      output = jobs.map((job: any) => job.customer_jobtype).join('\n');
    } else {
      output = '';
    }
    return output;
  }

  findEmployee(date): string {

    const jobs = this.jobs.filter((job: any) => job.schedule_date.split('T')[0] === date);
    let output = '';
    if (jobs.length > 0) {
      output = jobs.map((job: any) => job.employee_name).join('\n');
    } else {
      output = '';
    }
    return output;
  }

  selectDate(date: string): void {

    this.showApplogData = false;
    this.showEmailData = false;

    this.selectedDate = date;
    if(!this.fullStory){
      this.displayedData = this.data.formData.filter((obj: any) => {
        return obj.created_at.startsWith(date) && obj.thevalue && obj.thevalue.trim();
      });
    }else{
      this.displayedData = this.data.unfilteredData.filter((obj: any) => {
        return obj.created_at.startsWith(date) && obj.thevalue && obj.thevalue.trim();
      }).sort((a,b) => {
        return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
      });
    }

    this.filteredData = this.displayedData;
    const jobs = this.jobs.filter((job: any) => job.schedule_date.split('T')[0] === date);
    let output = '';
    if (jobs.length > 0) {
      output = jobs.map((job: any) => job.customer_jobtype).join('\n');
    } else {
      output = '';
    }
    this.jobOutput = output;
  }

  showEmailLogs(): void {

    this.jobOutput = "";
    this.isApplogDataLoaded = false;
    this.showEmailData = true;
    this.showApplogData = false;
    this.isEmailDataLoaded=true;
    this.displayedData = [];
    this.locService.getEmailLogs(this.data.location_id).subscribe(
      res => {
        this.isEmailDataLoaded=false;
        //replace ',' with ';' in message
        this.displayedData = res.EmailLogs.map((log: any) => {
          log.message = log.message.replace(/,/g, '; ');
          return log;
        });
      }, err => {
        this.isEmailDataLoaded = false; // Mark as loaded
      });
  }

  changeToApplog(): void {

      this.jobOutput = "";
      this.isEmailDataLoaded = false;
      this.showApplogData = true;
      this.showEmailData = false;
      this.displayedData = [];

      //wait
      if (!this.applogDataFetched) {
        this.applogViewRequested = true;
        this.isApplogDataLoaded = true;
        return; 
      }

      this.displayedData = [...new Map(this.applogData.map(item => [item.id, item])).values()];
      console.log(this.displayedData);
      if(this.displayedData.length === 0){
        this.displayedData.push({message: 'No applog data found for this location'});
      }
      this.filteredData = this.displayedData;

  }

  // Applog text around each "(TRIP)" marker, so the template can print the marker in bold.
  tripParts(message: string): string[] {
    return (message || '').split('(TRIP)');
  }

  trackByFn(index, obj) {
    return obj.created_at + obj.item; // or just obj.id if you have a unique id
  }

}